import { type KeystoneOfferEligibility } from "data/keystone-api-mapping";
import { usePolicyDetail } from "data/ss-data-hooks";
import { FeaturedOfferShingleReseal } from "pages/overview/featured-offers/featured-offer-shingle-reseal";
import { useFlags } from "utils";

import { FeaturedOfferAffiliateBlog } from "./featured-offer-affiliate-blog";
import { FeaturedOfferTing } from "./featured-offer-ting";

type FeaturedOffersProps = {
  offers: KeystoneOfferEligibility[];
};

export const FeaturedOffers = ({ offers }: FeaturedOffersProps) => {
  const { data: policy } = usePolicyDetail();
  const { affiliateBlog } = useFlags();
  const tingOffer = offers.find(
    (offer) => offer.offeringInternalName === "ting-offer",
  );
  const shingleResealOffer = offers.find(
    (offer) => offer.offeringInternalName === "wind-defense",
  );

  const showAffiliateBlog =
    policy?.userPolicyProperties.policyType == "HO3" && affiliateBlog;

  if (tingOffer) {
    return <FeaturedOfferTing />;
  } else if (shingleResealOffer) {
    return <FeaturedOfferShingleReseal />;
  } else if (showAffiliateBlog) {
    return <FeaturedOfferAffiliateBlog />;
  } else {
    return null;
  }
};
